import React, {
  useEffect,
  useState,
  useDeferredValue,
  useCallback,
} from "react";
import { Badge, Button, Dropdown, message, Spin, Typography } from "antd";
import {
  RetweetOutlined,
  GroupOutlined,
  FilterFilled,
  ExportOutlined,
  RedoOutlined,
  SearchOutlined,
  DollarOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import DndTable from "../../Components/DndTable/DndTable";
import { SelectColumns } from "../../Components/modals/SelectColumns";
import { AddComments } from "../../Components/modals/AddComments";
import { ViewComments } from "../../Components/modals/ViewComments";
import { RankingFilters } from "../../Components/modals/RankingFilter";
import { MoveRank } from "../../Components/modals/MoveRank";
import { Helmet } from "react-helmet";
import { RankingAPI } from "../../API/RankingAPI";
import CostSavings from "../../Components/modals/CostSavings";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import { ConfigurationAPI } from "../../API/ConfigurationAPI";
import BottomTab from "../../Components/BottomTab/BottomTab";
import { useFlightModel } from "../../contexts/FlightModelContext";
const { Text } = Typography;

export const Rankings = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [spinning, setSpinning] = useState(false);
  const [rankingData, setRankingData] = useState([]);
  const [openselectColumns, setOpenSelectColumns] = useState(false);
  const [openAddComments, setOpenAddComments] = useState(false);
  const [openViewComments, setOpenViewComments] = useState(false);
  const [openRankingFilter, setOpenRankingFilter] = useState(false);
  const [openMoveRank, setOpenMoveRank] = useState(false);
  const [openCostSavings, setOpenCostSavings] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedID, setSelectedID] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [dragableState, setDragableSatate] = useState(true);
  const [serachInput, setSearchInput] = useState("");
  const [defualtData, setDefualtData] = useState([]);
  const [lastFile, setLastFile] = useState("");
  const [selectedRowKeysar, setSelectedRowKeys] = useState([]);
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const [filteredValues, setFilteredvalues] = useState({
    cat: "",
    status: [],
    task: [],
    specType: "",
    // yieldValue: 90,
    yieldValueFrom: 0,
    yieldValueTo: 100,
    maintenanceCheck: "",
    maintenanceCheckPackage: "",
    maintenanceCheckInterval: "",
    maintenanceCheckPackageInterval: "",
  });
  const [filterStatus, setFilterStatus] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
   const { selectedFlightModel, refreshFlightModels } = useFlightModel();

  // useDefferedValue
  const deferredQuery = useDeferredValue(serachInput);
  useEffect(() => {
    serachFun();
  }, [deferredQuery]);

  const messageToast = useCallback(
    (type, message) => {
      messageApi.open({
        type: type,
        content: message,
        duration: 6,
      });
    },
    [messageApi],
  );

  const fetchColumnConfig = useCallback(async () => {
    setSpinning(true);
    try {
      const response = await RankingAPI.getColumnConfig();
      if (response?.data?.status === true) {
        const configColumns = response.data.all_columns
          .filter(
            (col) =>
              col.column_key !== "status" &&
              col.column_key !== "have_comments" &&
              col.column_key !== "is_drag" &&
              col.column_key !== "assigned_on" &&
              col.column_key !== "assigned_to",
          )
          .map((col) => {
            const existCol = response.data?.visible_columns?.find(
              (c) => c.column_key === col.column_key,
            );
            return {
              id: col.column_key,
              label: col.label,
              rank: existCol ? existCol.display_order : null,
            };
          })
          .filter((col) => col.rank !== null)
          .sort((a, b) => {
            const orderA =
              a.rank !== null ? parseInt(a.rank) : Number.MAX_SAFE_INTEGER;
            const orderB =
              b.rank !== null ? parseInt(b.rank) : Number.MAX_SAFE_INTEGER;
            return orderA - orderB;
          });

        setSelectedColumns(configColumns);
      }
    } catch (error) {
      messageToast("error", "Failed to fetch column configuration.");
    } finally {
      setSpinning(false);
    }
  }, [messageToast]);

  const getRankingData = useCallback(
    async function getRankingData(
      pageNo = page,
      perPage = pageSize,
      reset = false,
    ) {
      setSpinning(true);
        let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
      const queryParams = {
        params: {
          flight_model:flightModelToUse,
          //  localStorage.getItem("flight_model"),
          page: pageNo,
          page_size: perPage,
          spec_type: filteredValues.specType,
          status: filteredValues.status.map((ele) => ele.trim()).join(","),
          mntc_check: filteredValues.maintenanceCheck,
          mntc_check_package: filteredValues.maintenanceCheckPackage,
          mntc_check_interval: filteredValues.maintenanceCheckInterval,
          mntc_check_package_interval:
            filteredValues.maintenanceCheckPackageInterval,
          yield_min: filteredValues.yieldValueFrom,
          yield_max: filteredValues.yieldValueTo,
          fec: filteredValues.cat.trim(),
          task_type: filteredValues.task.map((ele) => ele.trim()).join(","),
          search: serachInput.trim(),
        },
      };

      await RankingAPI.getRannkList(queryParams)
        .then((res) => {
          if (res.data.status === true) {
            if (reset === false) {
              setRankingData(res.data.data);

              const hasFilter =
                filteredValues?.cat?.trim() !== "" ||
                filteredValues?.specType?.trim() !== "" ||
                filteredValues?.status?.length > 0 ||
                filteredValues?.task?.length > 0 ||
                filteredValues.yieldValueFrom !== 0 ||
                filteredValues.yieldValueTo !== 100 ||
                filteredValues?.maintenanceCheck?.trim() !== "" ||
                filteredValues?.maintenanceCheckPackage?.trim() !== "" ||
                filteredValues?.maintenanceCheckInterval?.trim() !== "" ||
                filteredValues?.maintenanceCheckPackageInterval?.trim() !==
                  "" ||
                serachInput.trim() !== "";
              if (!hasFilter) {
                setDragableSatate(true);
              } else {
                setDragableSatate(false);
              }
            } else {
              setSelectedRowKeys([]);
              setSelectedRow({});
              setSearchInput("");
              setFilteredvalues({
                cat: "",
                status: [],
                task: [],
                specType: "",
                // yieldValue: 90,
                yieldValueFrom: 0,
                yieldValueTo: 100,
                maintenanceCheck: "",
                maintenanceCheckPackage: "",
                maintenanceCheckInterval: "",
                maintenanceCheckPackageInterval: "",
              });
              setDragableSatate(true);
              setFilterStatus(false);
              setRankingData(res.data.data);
            }
            setTotalRecords(res.data.total);
            setPage(pageNo);
            setPageSize(perPage);
            setDefualtData(res.data.data);
            const arr = [{ value: null, label: "--select--" }];
            res.data?.employee_details.forEach((ele) => {
              arr.push({
                value: ele.username,
                label: `${ele.first_name} ${ele.last_name}`,
              });
            });
            setAssigneeOptions(arr);
            setSpinning(false);
          } else {
            messageToast("error", res.data?.message);
            setSpinning(false);
          }
        })
        .catch((err) => {
          messageToast("error", "Internal Server Error");
          setSpinning(false);
        })
        .finally(() => {
          // setSpinning(false)
        });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [page, pageSize, filteredValues, serachInput, messageToast],
  );

  async function resetRankFun() {
    setSpinning(true);
       let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    const queryParams = {
      params: {
        flight_model: flightModelToUse,
        // localStorage.getItem("flight_model"),
      },
    };
    await RankingAPI.resetRank(queryParams)
      .then((res) => {
        if (res.data.status === true) {
          getRankingData(page, pageSize, true);
        } else {
          messageToast("error", res.data?.message);
          setSpinning(false);
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
        setSpinning(false);
      });
    // .finally(() => setSpinning(false))
  }

  const loadConfigData = useCallback(
    async function loadConfigData() {
         let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
      const queryParams = {
        params: {
          flight_model:flightModelToUse,
          //  localStorage.getItem("flight_model"),
        },
      };
      await ConfigurationAPI.getCofigData(queryParams)
        .then((res) => {
          if (res.data.status === true) {
            let strDate = "";
            if (res.data?.data?.last_file?.uploaded_on) {
              strDate = new Date(res.data?.data?.last_file?.uploaded_on);
            }
            setLastFile(String(strDate).slice(4, 15));
          } else {
            messageToast("error", res.data?.message);
          }
        })
        .catch((err) => {
          messageToast("error", "Internal Server Error");
        });
    },
    [messageToast],
  );

  useEffect(() => {
    setSpinning(true);
    fetchColumnConfig();
    getRankingData(page, pageSize, false);
    loadConfigData();
  }, [page, pageSize, fetchColumnConfig, getRankingData, loadConfigData]);

  async function exportExcel() {
    setSpinning(true);
    try {
         let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
      const queryParams = {
        params: {
          flight_model:flightModelToUse,
          //  localStorage.getItem("flight_model"),
          spec_type: filteredValues.specType,
          status: filteredValues.status.map((ele) => ele.trim()).join(","),
          mntc_check: filteredValues.maintenanceCheck,
          mntc_check_package: filteredValues.maintenanceCheckPackage,
          mntc_check_interval: filteredValues.maintenanceCheckInterval,
          mntc_check_package_interval:
            filteredValues.maintenanceCheckPackageInterval,
          yield_min: filteredValues.yieldValueFrom,
          yield_max: filteredValues.yieldValueTo,
          fec: filteredValues.cat.trim(),
          task_type: filteredValues.task.map((ele) => ele.trim()).join(","),
          search: serachInput.trim(),
          export: true,
        },
      };

      const response = await RankingAPI.exportRankList(queryParams);

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Extract filename from content-disposition header if provided by backend
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "Ranking_export.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=(['"]?)([^'"\n;]*)\1/,
        );
        if (match?.[2]) fileName = match[2].trim();
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      messageToast("error", "Export failed. Please try again.");
    } finally {
      setSpinning(false);
    }
  }

  async function serachFun() {
    setSelectedRowKeys([]);
    setSelectedRow({});
    setSpinning(true);
    getRankingData(1, pageSize, false);
  }

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | Ranking</title>
      </Helmet>
      <HeaderTab currrentTab="ranking" />

      <Spin spinning={spinning}>
        <div className="box_wraper_div">
          <div className="table_head_wraper">
            <Text className="table_head">
             Ranking for the month of{" "}
{new Date().toLocaleString("default", { month: "long" })}
            </Text>
            <div className="table_custom_buttons">
              <div
                style={{
                  borderRadius: "25px",
                  backgroundColor: "#EBEEF8",
                  color: "#737373",
                  display: "flex",
                }}
              >
                <input
                  value={serachInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  className="searc_input"
                />
                <SearchOutlined
                  className="search_btn"
                  style={{
                    color: !serachInput ? "#737373" : "#ff4d4f",
                    fontSize: "18px",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              </div>
              <Button
                onClick={() => setOpenMoveRank(true)}
                type="primary"
                style={{ flex: "1 1 0px " }}
                icon={<RetweetOutlined />}
              >
                Move
              </Button>
              <Button
                onClick={() => {
                  if (
                    selectedRow?.id &&
                    selectedRow?.id !== "" &&
                    selectedRow?.id !== null
                  ) {
                    setOpenCostSavings(true);
                  } else {
                    messageToast(
                      "warning",
                      "Please select a spec to view cost savings",
                    );
                  }
                }}
                type="primary"
                style={{ flex: "1 1 0px " }}
                icon={<DollarOutlined />}
              >
                Cost Savings
              </Button>
              <Dropdown
                placement="bottomRight"
                menu={{
                  items: [
                    {
                      key: "1",
                      label: (
                        <div
                          onClick={() => setOpenSelectColumns(true)}
                          style={{ fontSize: "18px", minWidth: "150px" }}
                        >
                          <GroupOutlined />{" "}
                          <Text style={{ marginLeft: "10px" }}>Columns</Text>
                        </div>
                      ),
                    },
                    {
                      key: "2",
                      label: (
                        <div
                          onClick={() => setOpenRankingFilter(true)}
                          style={{ fontSize: "18px", minWidth: "150px" }}
                        >
                          <Badge dot={filterStatus}>
                            <FilterFilled />{" "}
                          </Badge>{" "}
                          <Text style={{ marginLeft: "10px" }}>Filter</Text>
                        </div>
                      ),
                    },
                    {
                      key: "3",
                      label: (
                        <div
                          onClick={exportExcel}
                          style={{ fontSize: "18px", minWidth: "150px" }}
                        >
                          <ExportOutlined />{" "}
                          <Text style={{ marginLeft: "10px" }}>
                            Export to Excel
                          </Text>
                        </div>
                      ),
                    },
                    {
                      key: "4",
                      label: (
                        <div
                          onClick={() => resetRankFun()}
                          style={{ fontSize: "18px", minWidth: "150px" }}
                        >
                          <RedoOutlined />{" "}
                          <Text style={{ marginLeft: "10px" }}>Reset</Text>
                        </div>
                      ),
                    },
                  ],
                }}
                trigger={["click"]}
              >
                <Badge dot={filterStatus}>
                  <Button
                    disabled={defualtData.length > 0 ? false : true}
                    type="primary"
                    style={{
                      backgroundColor: "#EBEEF8",
                      color: "#304CB2",
                      flex: "1 1 0px ",
                    }}
                    icon={<EllipsisOutlined />}
                  >
                    Actions
                  </Button>
                </Badge>
              </Dropdown>
            </div>
          </div>

          <DndTable
            listData={rankingData}
            selectedColumns={selectedColumns}
            setOpenAddComments={setOpenAddComments}
            setSelectedID={setSelectedID}
            setOpenViewComments={setOpenViewComments}
            getRankingDataFun={getRankingData}
            setSpinning={setSpinning}
            setSelectedRow={setSelectedRow}
            selectedRow={selectedRow}
            dragableState={dragableState}
            messageToast={messageToast}
            selectedRowKeysar={selectedRowKeysar}
            setSelectedRowKeys={setSelectedRowKeys}
            assigneeOptions={assigneeOptions}
            page={page}
            pageSize={pageSize}
            totalRecords={totalRecords}
            filteredValues={filteredValues}
            serachInput={serachInput}
            setPage={setPage}
            setPageSize={setPageSize}
            setTotalRecords={setTotalRecords}
            setRankingData={setRankingData}
          />

          <SelectColumns
            open={openselectColumns}
            setOpen={setOpenSelectColumns}
            setSelectedColumns={setSelectedColumns}
            messageToast={messageToast}
          />
          <AddComments
            open={openAddComments}
            setOpen={setOpenAddComments}
            selectedID={selectedID}
            listData={rankingData}
            setListData={setRankingData}
            messageToast={messageToast}
            assigneeOptions={assigneeOptions}
          />
          <ViewComments
            open={openViewComments}
            setOpen={setOpenViewComments}
            selectedID={selectedID}
            setOpenAddComments={setOpenAddComments}
            messageToast={messageToast}
          />
          <RankingFilters
            open={openRankingFilter}
            setOpen={setOpenRankingFilter}
            listData={rankingData}
            setListData={setRankingData}
            getRankingDataFun={getRankingData}
            setDragableSatate={setDragableSatate}
            setFilterStatus={setFilterStatus}
            serachInput={serachInput}
            defualtData={defualtData}
            setSearchInput={setSearchInput}
            filteredValues={filteredValues}
            setFilteredvalues={setFilteredvalues}
            setTotalRecords={setTotalRecords}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            messageToast={messageToast}
          />
          <MoveRank
            open={openMoveRank}
            setOpen={setOpenMoveRank}
            selectedRow={selectedRow}
            listData={rankingData}
            getRankingDataFun={getRankingData}
            dragableState={dragableState}
            messageToast={messageToast}
            setSelectedRowKeys={setSelectedRowKeys}
            setSelectedRow={setSelectedRow}
          />
          <CostSavings
            open={openCostSavings}
            setOpen={setOpenCostSavings}
            selectedRow={selectedRow}
            messageToast={messageToast}
          />
        </div>
      </Spin>

      <BottomTab lastFile={lastFile} />
      {contextHolder}
    </div>
  );
};
